var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCsvLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00008 1.66667C3.07961 1.66667 2.33341 2.41286 2.33341 3.33333V16.6667C2.33341 17.5871 3.07961 18.3333 4.00008 18.3333H14.0001C14.9206 18.3333 15.6667 17.5871 15.6667 16.6667V11.0706C15.6667 10.8642 15.6572 10.6586 15.6382 10.4545C15.4557 9.25355 14.4187 8.33333 13.1667 8.33333H11.4343C10.2837 8.33333 9.35096 7.40059 9.35096 6.25V4.16667C9.35096 2.87041 8.36441 1.80457 7.10119 1.67903C6.96639 1.67081 6.83095 1.66667 6.69502 1.66667H4.00008ZM4.00008 0H6.85096C6.98077 0 7.1092 0.00593652 7.23599 0.017553C9.49279 0.164213 11.6025 1.22379 13.0693 2.96554L15.3743 5.7028C16.4625 6.995 17.128 8.58208 17.293 10.2506C17.3196 10.441 17.3334 10.6356 17.3334 10.8333V16.6667C17.3334 18.5076 15.841 20 14.0001 20H4.00008C2.15913 20 0.666748 18.5076 0.666748 16.6667V3.33333C0.666748 1.49238 2.15913 0 4.00008 0ZM14.0944 6.77031L11.7944 4.03909C11.5206 3.71394 11.2188 3.4185 10.894 3.15513C10.9748 3.47897 11.0176 3.81782 11.0176 4.16667V6.25C11.0176 6.48012 11.2042 6.66667 11.4343 6.66667H13.1667C13.4856 6.66667 13.7961 6.70248 14.0944 6.77031Z",
    fill: "#CA2867"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsvLogo);
export default __webpack_public_path__ + "static/media/CSVLogo.96bf5a6e0c6d9d5d5c653202e573ef29.svg";
export { ForwardRef as ReactComponent };